<app-ion-common-header [id]="headerId" (backHeader)="backPage()" (focusHeader)="shownContent()" [title]="titlePage" start="{{startStage}}" end="{{endStage}}"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">
  
<app-ion-common-label class="document-type-label1" labelStyle="display-rg"
  labelDescription="Qual o seu e-mail?">
</app-ion-common-label>

<form [formGroup]="emailForm" (ngSubmit)="submitForm($event)">
  <div class="conent-center conent-center--mrt-lg">
      <app-ion-common-input
        [placeholder]="hideSecondInput ? 'E-mail' : placeholder" 
        [error]="error" 
        [id]="idComponentName"
        [textError]="textError"
        maxLength="255"
        (textChange)="email=$event; errorMsg(); hideSecondInput = false;"
        type="text"
        [fieldValue]="email"
        [idLabel]="idLabel"
        [replaceStrTo]="'email'"
        [label]="label"
        name="docEmail"
        [disabled]="!this.edit"
        formControlName="docEmail"
        [labelInputText]="hideSecondInput"
        ngDefaultControl>
      </app-ion-common-input>
    </div>
    <div class="conent-center" [ngClass]="{'hide': hideSecondInput}">
      <app-ion-common-input
        [placeholder]="placeholderConfirm" 
        [error]="errorRepeated" 
        [id]="idComponentNameRepeated"
        [textError]="textErrorRepeated"
        maxLength="255"
        (textChange)="emailRepeated=$event; editInput = true; errorMsg();"
        type="text"
        [fieldValue]="emailRepeated"
        [idLabel]="idLabel"
        [replaceStrTo]="'email'"
        [label]="label"
        name="docEmailRepeated"
        [disabled]="!this.edit"
        formControlName="docEmailRepeated"
        ngDefaultControl>
      </app-ion-common-input>
    </div>
  </form>
  <app-ion-common-button class="hidden" [ngClass]="{'hidden': !buttonEnable || (!hideSecondInput && buttonEnable && !editInput)}" [attr.aria-hidden]="!buttonEnable" (clickButton)="clickNext();" label="Continuar"></app-ion-common-button>
</ion-content>